import * as service from './service'
export default {
  namespace: 'messageHome',
  state: {
    typeInfoData: [],
    listData: []
  },
  effects: {
    * getNoticeTypeInfo ({ payload }, { call, put }) {
      const res = yield call(service.getNoticeTypeInfo, payload)
      yield put({
        type: 'save',
        payload: {
          typeInfoData: res.data.data
        }
      })
      return res.data
    },
    * getList ({ payload }, { call, put }) {
      const res = yield call(service.getList, payload)
      yield put({
        type: 'save',
        payload: {
          listData: res.data.data
        }
      })
      return res.data
    },
    * pullData ({ payload }, { call, put }) {
      const res = yield call(service.pullData, payload)
      yield put({
        type: 'save',
        payload: {
          listData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
